import React from 'react';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import CDNImage from '../../../../components/CDNImage';

// Material components
import {
    IconButton,
    Toolbar,
} from '@material-ui/core';

// Material icons
import {
    ChevronLeft as ChevronLeftIcon,
    InfoOutlined as InfoIcon,
    Clear as CloseIcon,
} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';

// Component styles
const useStyles = makeStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.border}`,
        display: 'flex',
        alignItems: 'center',
        height: '64px',
        zIndex: theme.zIndex.appBar
    },
    toolbar: {
        minHeight: 'auto',
        width: '100%',
        height: '70px'
    },
    title: {
        marginLeft: theme.spacing(1)
    },
    menuButton: {
        marginLeft: '-4px',
        color: theme.palette.common.white,
    },
    menuButtonBlack: {
        marginLeft: '-4px',
        color: theme.palette.text.secondary,
    },
    notificationsButton: {
        marginLeft: 'auto'
    },
    bookingSourceImage: {
        maxWidth: '120px'
    },
    infoButton: {
        marginLeft: 'auto',
        color: theme.palette.common.white,
    },
    infoButtonBlack: {
        marginLeft: 'auto',
        color: theme.palette.text.secondary,
    }
}));

const Topbar = props => {
    const {
        rootProps,
        bookingSourceImage,
        onBack,
        onInfo,
        isDesktop,
        overlay,
        reservation,
    } = props;

    const classes = useStyles();

    let backIcon = <ChevronLeftIcon/>;
    if (overlay && overlay === 'Help') {
        backIcon = <CloseIcon/>
    }

    return (
        <div {...rootProps}>
            <Toolbar className={classes.toolbar}>
                {onBack &&
                <IconButton
                    className={classNames(classes.menuButton, {[classes.menuButtonBlack]: isDesktop})}
                    onClick={onBack}
                    variant="text"
                >
                    {backIcon}
                </IconButton>
                }
                {bookingSourceImage &&
                <CDNImage
                    src={bookingSourceImage}
                    userId={reservation.hid}
                    size="original"
                    filename="secondary"
                    className={classes.bookingSourceImage}
                />
                }
                {onInfo &&
                <IconButton
                    className={classNames(classes.infoButton, {[classes.infoButtonBlack]: isDesktop})}
                    onClick={onInfo}
                >
                    <InfoIcon/>
                </IconButton>
                }
            </Toolbar>
        </div>
    );
};

Topbar.propTypes = {
    onInfo: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    bookingSourceImage: PropTypes.string,
    onBack: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
    isDesktop: PropTypes.bool.isRequired,
    reservation: PropTypes.object.isRequired,
};

Topbar.defaultProps = {
    isDesktop: false
};

export default Topbar;